import { normalizeMenuUrl } from "./menuUrl";

const PAGE_LABEL_BY_PREFIX = [
  { prefix: "/manual", label: "Manual" },
  { prefix: "/resources", label: "Resources" },
  { prefix: "/about-us", label: "About Us" },
  { prefix: "/products", label: "Our Products" },
  { prefix: "/news", label: "News" },
  { prefix: "/downloads", label: "Downloads" },
  { prefix: "/contact-us", label: "Contact Us" },
];

const CONTENT_CATEGORY_PAGE_LABELS = {
  news: "News",
  product: "Our Products",
  download: "Downloads",
  support: "Resources",
};

export function resolveContentCategory(contentType) {
  if (!contentType) return null;

  const value = String(contentType).toLowerCase();

  if (CONTENT_CATEGORY_PAGE_LABELS[value]) {
    return value;
  }

  if (value.includes("newsletter") || value.includes("cas-new") || value.includes("news-list") || value.includes("news-page")) {
    return "news";
  }

  if (value.includes("support")) {
    return "support";
  }

  if (value.includes("download")) {
    return "download";
  }

  if (
    value.includes("product") ||
    value.includes("sensaphone") ||
    value.includes("raychem") ||
    value.includes("tracetek") ||
    value.includes("picobox")
  ) {
    return "product";
  }

  return null;
}

/**
 * Map a search hit URL to a top-level site page label (English).
 */
export function getPageLabelFromUrl(url) {
  const normalized = normalizeMenuUrl(url);
  if (!normalized) return null;

  if (/^https?:\/\//i.test(normalized)) {
    return "External";
  }

  const path = normalized.split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";

  if (path === "/") return "Home";

  const match = PAGE_LABEL_BY_PREFIX.find(
    ({ prefix }) => path === prefix || path.startsWith(`${prefix}/`)
  );

  return match?.label || null;
}

/**
 * Fallback page label from Strapi content type when URL is missing.
 */
export function getPageLabelFromContentType(contentType) {
  const category = resolveContentCategory(contentType);
  return category ? CONTENT_CATEGORY_PAGE_LABELS[category] : null;
}

/**
 * Resolve the top-level page label for a search hit.
 */
export function getSearchHitPageLabel({ url, contentType }) {
  const fromUrl = getPageLabelFromUrl(url);
  if (fromUrl) return fromUrl;

  const fromContentType = getPageLabelFromContentType(contentType);
  if (fromContentType) return fromContentType;

  return "Content";
}
